import { type IOProps } from "./io-abstract";
import IOList from "./io-list";

export default function IOListNumber(
  props: { list: string[] } & IOProps<number | undefined>
) {
  return (
    <IOList
      {...props}

      // Type conversion (number -> string)
      value={props.value == null ? "" : `${props.value}`}
      onChange={(value: string) =>
        props.onChange?.(value == "" ? undefined : Number(value))
      }
    />
  );
}
